// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { FC } from 'react';
import { Text } from '@mantine/core';
import { ProcedureReportProps, ShareEntityConfigDTO } from '../../../../Types/LogT';
import { getReportExecutionState } from './reportExecutionState';

const ShareEntityReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const cfg = config as ShareEntityConfigDTO;
  const { entityReference } = cfg;
  const { label } = entityReference;
  const executionState = getReportExecutionState(report?.executionStatus);

  return (
    <Text>
      {executionState === 'SKIPPED' ? 'Teilen von ' : ''}
      <Text span weight="bolder">
        {label}
      </Text>{' '}
      {executionState === 'COMPLETED' && 'wurde geteilt.'}
      {executionState === 'PLANNED' && 'wird geteilt.'}
      {executionState === 'SKIPPED' && 'wurde übersprungen.'}
      {executionState === 'NOT_EXECUTED' && 'wurde nicht geteilt.'}
    </Text>
  );
};

export default ShareEntityReport;
